import type { ErrorCodeString } from "./types";

interface ErrorMessageConfig {
  title: string;
  message: string;
}

// Error messages mapped by specific error codes from backend
export const ERROR_CODE_MESSAGES: Record<ErrorCodeString, ErrorMessageConfig> = {
  INVALID_BU_CODE: {
    title: "Invalid Business Unit Code",
    message:
      "The Business Unit code in your file is not recognized. Please verify the BU code is correct or contact your administrator to add it to the system.",
  },
  INVALID_FILENAME_PATTERN: {
    title: "Invalid File Name Format",
    message:
      "Your file name does not match the required pattern: GOT_<bu_code>_<type>_DISBURSEMENT_YYYYMMDD.csv. Please rename your file and try again.",
  },
  INVALID_REQUEST: {
    title: "Invalid Request",
    message: "The request contains invalid or missing data. Please check your file and try again.",
  },
  DUPLICATE_DISBURSEMENT: {
    title: "File Already Processed",
    message:
      "This file has already been uploaded for disbursement. Please upload the disbursement report to complete the process.",
  },
  SERVICE_LOCKED: {
    title: "Service Temporarily Disabled",
    message:
      "The disbursement service is currently disabled. Please contact your system administrator for more information.",
  },
  PROCESSING_FAILED: {
    title: "Processing Failed",
    message:
      "An internal error occurred while processing your file. Please contact support if this error persists.",
  },
  INTERNAL_ERROR: {
    title: "Internal Server Error",
    message: "An unexpected error occurred. Please contact support if this error persists.",
  },
  UNAUTHORIZED: {
    title: "Authentication Required",
    message: "Your session has expired. Please log in again.",
  },
  FORBIDDEN: {
    title: "Access Denied",
    message:
      "You do not have permission to perform this action. Please contact your administrator.",
  },
};

// Status code based fallback messages
export const STATUS_CODE_MESSAGES: Record<number, ErrorMessageConfig> = {
  400: {
    title: "Invalid Request",
    message: "The request is invalid. Please check your data and try again.",
  },
  401: {
    title: "Authentication Required",
    message: "Your session has expired. Please log in again.",
  },
  403: {
    title: "Access Denied",
    message: "You do not have permission to perform this action.",
  },
  408: {
    title: "Request Timeout",
    message: "The request took too long to process. Please try again.",
  },
  423: {
    title: "Service Locked",
    message: "This service is currently unavailable. Please contact your administrator.",
  },
  500: {
    title: "Internal Server Error",
    message: "An internal error occurred. Please contact support if this error persists.",
  },
  502: {
    title: "Service Error",
    message:
      "Unable to reach the disbursement service. Please try again later or contact support if this error persists.",
  },
  503: {
    title: "Service Unavailable",
    message:
      "The disbursement service is temporarily unavailable. Please try again later or contact support if this error persists.",
  },
  504: {
    title: "Gateway Timeout",
    message:
      "The request timed out. Please try again later or contact support if this error persists.",
  },
};
